import React from "react";
import { Redirect } from "react-router-dom";

/**
 * ClientWorkReports serves as the primary route container for Client Work reports.
 * Redirects to the master Contract Billing Abstract report screen.
 */
const ClientWorkReports = () => {
  return <Redirect to="/client-work/reports/contract-billing-abstract" />;
};

export default ClientWorkReports;
